angular.module('leanlaw').directive('llBillingActivity', [function () {
  return {
    restrict: 'AE',
    template: require("./views/billingActivity.html"),
    scope: {
      client: "=",
      matter: "="
    },
    controller: ['$scope', 'singleRequest', '$q', '$filter', 'alerts', '$window', 'exportJson', 'viewInvoiceService', function ($scope, singleRequest, $q, $filter, alerts, $window, exportJson, viewInvoiceService) {
      let localTrustLoaded = false;
      $scope.vm = {
        transactions: [],
        sort: 'date',
        reverse: true,
        client: undefined,
        matter: undefined
      };
      activate();
      function activate() {
        $scope.$watch('matter', matter => {
          if (matter) {
            $scope.vm.matter = matter;
            loadTransaction({
              matterId: matter.id
            });
          }
        });
        $scope.$watch('client', client => {
          if (client) {
            $scope.vm.client = client;
            loadTransaction({
              clientId: client.id
            });
          }
        });
      }
      function loadTransaction(query) {
        const load = [];
        load.push(singleRequest.apiCall("invoices").listInvoices(query).then(({
          invoices
        }) => {
          if (!invoices) return;
          invoices.forEach(invoice => {
            $scope.vm.transactions.push({
              date: invoice.invoiceDate,
              referenceLabel: invoice.reference,
              invoices: [invoice],
              amount: invoice.totals.billedAmount ?? invoice.totals.amount,
              matters: invoice.matters.length ? invoice.matters : [invoice.matter],
              type: 'Invoice',
              invoice
            });
          });
        }));
        load.push(singleRequest.apiCall("payments").listPayments(query).then(({
          payments
        }) => {
          if (!payments) return;
          payments.forEach(payment => {
            $scope.vm.transactions.push({
              date: payment.date,
              amount: payment.amount,
              matters: payment.matter && [payment.matter],
              type: 'Payment',
              referenceLabel: payment.invoices.map(i => i.invoice.reference).join(', '),
              invoices: payment.invoices.map(i => i.invoice)
            });
          });
        }));
        $scope.loading = true;
        $q.all(load).catch(err => {
          alerts.error(err);
        }).finally(() => {
          $scope.loading = false;
        });
      }
      $scope.export = () => {
        const transactions = $scope.vm.sortedTransactions.filter(t => $scope.vm.trust || !t.trust);
        if (transactions.length == 0) return;
        const exp = transactions.reduce((accum, t) => {
          accum.push({
            "Date": $filter("date")(t.date, "MM/dd/yy"),
            "Type": t.type,
            "Invoice(s)": t.invoices?.map(i => {
              if (!i.accounting) {
                return i.state.draft ? 'Draft' : i.state.review ? 'Review' : i.state.approved ? 'Approved' : '';
              }
              return i.reference;
            }).join(','),
            "Matter": t.matters?.map(m => m.label).join(','),
            "Amount": $filter("amount")(t.amount),
            "Balance": $filter("amount")(t.invoice?.state?.balance)
          });
          return accum;
        }, []);
        exportJson.downloadCsv(exp);
      };
      $scope.trustCheckbox = () => {
        if (!localTrustLoaded) {
          const trustQuery = {
            transactions: true
          };
          if ($scope.vm.matter) {
            trustQuery.id = $scope.vm.matter.billing.trust.account.id;
          } else {
            trustQuery.id = $scope.vm.client.billing.trust.account.id;
          }
          $scope.trustLoading = true;
          singleRequest.apiCall("transactions").getAccountingAccount(trustQuery).then(trust => {
            if (!trust) return;
            localTrustLoaded = true;
            trust.transactions.forEach(transaction => {
              $scope.vm.transactions.push({
                date: transaction.date,
                amount: transaction.amount,
                type: `Trust: ${transaction.type}`,
                trust: true
              });
            });
          }).catch(err => {
            alerts.error(err);
          }).finally(() => {
            $scope.trustLoading = false;
          });
        }
      };
      $scope.openInQBO = invoice => {
        $window.open(invoice.accounting.href);
      };
      $scope.viewInvoice = invoice => {
        viewInvoiceService.viewInvoice(invoice, true);
      };
      $scope.sendEmail = invoice => {
        viewInvoiceService.sendEmail(invoice);
      };
    }]
  };
}]);